import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Pin: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M14.3342 1.52997C13.7815 2.34509 12.7745 3.83013 12.0965 4.83012L10.8638 6.64826L10.6459 6.71604C10.526 6.75333 8.10791 7.51661 5.27231 8.41224L0.116677 10.0406L3.22026 13.1443L6.32387 16.248L3.15594 19.416L-0.0119629 22.584L0.701989 23.2979L1.41597 24.0119L4.58394 20.844L7.75194 17.676L10.8556 20.7797L13.9593 23.8832L15.5877 18.7276C16.4833 15.892 17.2466 13.4738 17.284 13.3537L17.3518 13.1355L20.6219 10.9203C22.4204 9.70195 23.9079 8.69028 23.9275 8.67213C23.9583 8.64355 23.3901 8.06623 19.6675 4.34357C17.305 1.98098 15.3646 0.0479736 15.3555 0.0479736C15.3465 0.0479736 14.8869 0.714862 14.3342 1.52997ZM13.8843 5.77233L12.1349 8.35269L11.7734 8.46753C11.5746 8.5307 9.71924 9.11642 7.65037 9.76917L3.88883 10.956L8.46637 15.534C10.984 18.0519 13.0462 20.1039 13.0491 20.094C13.0578 20.0631 15.3798 12.7071 15.5174 12.2742L15.6477 11.8645L18.2098 10.1289C19.619 9.17426 20.7825 8.38368 20.7953 8.37201C20.8097 8.35896 19.8278 7.35991 18.2394 5.7714C16.8207 4.35271 15.6541 3.19197 15.6469 3.19197C15.6396 3.19197 14.8465 4.35314 13.8843 5.77233Z'
        fill={fill}
      />
    </svg>
  )
}

export default Pin
